import { createContext } from 'react';

const prescriptionModalContext = createContext({
    prescriptionModal: {},
    setPrescriptionModal: () => {}
});

export default prescriptionModalContext;
